module.exports = __webpack_public_path__ + "static/media/paypal-social-media-svgrepo-com.16e93017.svg";